import { type FC } from "react";
import Modal from "@root/shared/components/Modal";
import { Icon } from "@root/shared/components/Icon";
import { SearchCondition } from "./uiParts/SearchCondition";
import * as styles from "./styles.css";

type Props = {
  settingSearchConditionsPath: string;
  searchConditions: SearchCondition[];
  onClickShowSearchConditionsButton: () => void;
  isModalOpen: boolean;
  onCloseModal?: () => void;
};

type SearchCondition = {
  id: string;
  searchConditionName: string;
  clientShopName: string;
  searchConditionDetail: string;
  searchPath: string;
};

export const Presentation: FC<Props> = ({
  settingSearchConditionsPath,
  searchConditions,
  onClickShowSearchConditionsButton,
  isModalOpen,
  onCloseModal,
}) => {
  return (
    <>
      <div className={styles.textAlignRight}>
        <button type="button" className={styles.button} onClick={onClickShowSearchConditionsButton}>
          <div className={styles.iconWrapper}>
            <Icon name="search" fontSize="12px" />
          </div>
          保存した検索条件
        </button>
      </div>

      <Modal
        headerTitle="保存した検索条件"
        isShow={isModalOpen}
        onClose={onCloseModal}
        spAppearanceType="center"
        pcWidthType="large"
      >
        <>
          <div className={styles.textAlignRight}>
            <a href={settingSearchConditionsPath}>保存した条件の設定 {">"}</a>
          </div>
          {searchConditions.map((item: SearchCondition) => (
            <SearchCondition
              key={item.id}
              title={item.searchConditionName}
              clientShopName={item.clientShopName}
              conditions={item.searchConditionDetail}
              href={item.searchPath}
            />
          ))}
        </>
      </Modal>
    </>
  );
};
